module.exports = __webpack_public_path__ + "static/media/brands_GLOBAL.46b0c58a.svg";